export default {
  GET_TARGET: "/api/v1/order-carts/address-reinput-target",
};
